export enum DrawingButtonsMode {
  marker = 0,
  area = 2,
  circle = 1,
}
